import { store, getContext } from '@wordpress/interactivity';

store( "gt/asterio/form-resa", {
    actions:{
        initFormResa: function(){
            
          astJQuery(document).ready(function ($) {

            const options = store('gt/asterio').state.options;

            $("#be-messages").ModuleMessage({
              kmlCode: KML_CODE,
              templateCode: TEMPLATE_CODE,
            });

            $("#multisite-selection").ModuleSelectionSite({
              kmlCode: KML_CODE,
              templateCode: TEMPLATE_CODE,
              messageHandler: $("#be-messages"),
            });

            $("#datepicker").ModuleDatepicker({
              kmlCode: KML_CODE,
              templateCode: TEMPLATE_CODE,
              messageHandler: $("#be-messages"),
              showOnClick: true,
              appendInlineDatePickerTo: '#booking-datepicker',
              'sqs.loadtemplatedone': function (event, data) {

                $('[name="check-in-readonly"]').css('pointer-events', 'none');
                $('[name="check-out-readonly"]').css('pointer-events', 'none');
                //button prev & next
                $('.ui-icon-circle-triangle-e').removeClass('ui-icon-circle-triangle-e').addClass('icon-next');
                $('.ui-icon-circle-triangle-w').removeClass('ui-icon-circle-triangle-w').addClass('icon-prev');

              },

              'sqs.searchdone': function (event, data) {
                // document.location.href = "channel.jsp?page=results";
                $("#datepicker").ModuleDatepicker('redirect', options.search_results_page + '?_ast_page=results');
              },
            });

            $("#occupants-selection").ModuleOccupants({
              kmlCode: KML_CODE,
              templateCode: TEMPLATE_CODE,
              messageHandler: $("#be-messages"),
            });

            $("#categoryChoice").ModuleCategorySelection({
              kmlCode: KML_CODE,
              templateCode: TEMPLATE_CODE,
              categoryCodes: ["ALL"],
              messageHandler: $("#be-messages"),
              preventDefault: true,
            });

            $("#codeCorporate").ModuleCodeCorporate({
              kmlCode: KML_CODE,
              templateCode: TEMPLATE_CODE,
              messageHandler: $("#be-messages"),
            });

            $("#channelChoice").ModuleChannelChoice({
              kmlCode: KML_CODE,
              templateCode: TEMPLATE_CODE,
              messageHandler: $("#be-messages"),
            });

          });

        }
    }
  } );
